import { Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { TwentyOne } from 'game-logic';
import { VerticalCardStackViewModel } from './vertical-card-stack-view-model';
import { ChevronHintViewModel } from './chevron-hint-view-model';
import { TwentyOneAssetType } from '../../model/twentyone-types';

export class ColumnStackViewModel {
  public get columnBoxFillAsset() {
    return this.gameServices.assetCatalogueService.getAsset(TwentyOneAssetType.ColumnBoxFill);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onGameSetupStart$() {
    return this.gameServices.twentyOneGameRunner.onGameSetupStart$;
  }
  public get onGameSetupComplete$() {
    return this.gameServices.twentyOneGameRunner.onGameSetupComplete$;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get canClick() {
    return this.enableClick;
  }
  public get columnIndex() {
    const i = this.columnId as number;
    return i <= 2 ? i - 3 : i - 3;
  }

  private readonly onResetGameScene = new Subject<void>();
  public readonly chevronHintViewModel: ChevronHintViewModel;
  public readonly cardStackViewModel: VerticalCardStackViewModel;

  private enableClick = false;

  constructor(
    private gameServices: GameServices,
    public readonly columnId: TwentyOne.PileId,
  ) {
    this.chevronHintViewModel = new ChevronHintViewModel(gameServices, columnId);
    this.cardStackViewModel = new VerticalCardStackViewModel(gameServices, columnId);
  }

  public resetGameScene(): void {
    this.chevronHintViewModel.resetGameScene();
    this.cardStackViewModel.resetGameScene();

    this.onResetGameScene.next();
  }

  public enableInput(enable: boolean) {
    this.enableClick = enable;
  }

  public performClick(): void {
    if (this.enableClick) {
      this.gameServices.twentyOneGameRunner.clickColumn(this.columnId);
    }
  }
}
